<template>
  <div>
    <!--    <input ref="fileUpload" :name="name" :accept="accept" hidden type="file" @change="checkFile"> -->
    <!-- 预览模式 -->
    <div class="SpUpload" :class="{'upload-failed':file.status==='failed'}" :style="{ width: widthC,height:heightC}">
      <SpLoading v-if="file.status==='uploading'" mask>上传中...</SpLoading>
      <div class="flex-center main max-box pointer">
        <!-- 遮罩层 -->
        <div v-if="file.url" :style="{ width: widthC,height:(height-20)+'px'}" class="mask" @click.capture="showFullView" />
        <!-- 关闭按钮 -->
        <span v-if="file.url" :style="{visibility: disabled ? 'hidden' : 'visible'}" class="close-icon icon sp-color-4" @click.capture="deleteFile"><span class="icon-close iconfont" /></span>
        <!-- 添加按钮 -->
        <div v-else>
          <svg t="1627895209590" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7465" width="100" height="100" @click.capture="selectFile"><path d="M511.914667 960a21.333333 21.333333 0 0 1-21.333334-21.333333l0.128-853.333334a21.333333 21.333333 0 1 1 42.666667 0l-0.128 853.333334a21.333333 21.333333 0 0 1-21.333333 21.333333z" p-id="7466" fill="#bfbfbf" /><path d="M938.666667 533.312H85.333333a21.333333 21.333333 0 1 1 0-42.666667h853.333334a21.333333 21.333333 0 1 1 0 42.666667z" p-id="7467" fill="#bfbfbf" /></svg>
          <br>
          <p v-if="upTitle" style="font-size: 24px; color: #bfbfbf" class="text-center">{{ upTitle }}</p>
        </div>

        <!-- 图片预览 -->
        <img v-if="file.type=='img'&&file.url" class="img" :width="width" :height="height" :src="file.url">
        <!-- pdf等其他文件预览 -->
        <iframe v-if="file.type=='pdf'&&file.url" class="preview-iframe" scrolling="no" :width="(width+50)+'px'" :height="(height+100)+'px'" frameborder="0" :src="file.url" />
        <svg v-if="file.type=='other'&&file.url" t="1628148530356" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2858" width="200" height="200"><path d="M858.251002 65.538669 709.22692 65.538669l-0.204661 0.184195c-0.112564 0-0.204661-0.038886-0.312108-0.038886-13.967106 0-25.461905 10.3006-27.538193 23.667026l-0.248663 0.225127c-7.556093 33.045627-18.427698 76.41232-53.822836 76.41232l-246.183935-1.517563c-34.927487 0-45.37442-42.771129-53.413514-75.16491-1.36509-13.386892-12.069897-23.892153-25.568329-24.910343l-0.370437-0.375553L165.181063 64.020082c-20.552082 0-37.239136 16.666588-37.239136 37.239136l0 819.454394c0 20.571525 16.686031 37.238113 37.239136 37.238113l693.049472 1.517563c20.557198 0 37.239136-16.666588 37.239136-37.238113L895.469672 102.777805C895.490138 82.205257 878.788757 65.538669 858.251002 65.538669L858.251002 65.538669 858.251002 65.538669zM858.251002 922.232199l-693.069939-1.517563L165.181063 101.260242l126.998439 0c9.087982 36.459377 26.38288 100.44569 88.810698 100.44569l246.183935 1.517563c62.952774 0 80.69281-64.810075 88.940658-100.44569L858.230536 102.777805l0 819.454394L858.251002 922.232199 858.251002 922.232199 858.251002 922.232199zM407.172513 101.372805l209.110575 1.517563c10.295484 0 18.61701-8.346085 18.61701-18.622126 0-10.277064-8.321526-18.61701-18.61701-18.61701L407.172513 64.133669c-10.281157 0-18.622126 8.339946-18.622126 18.61701C388.550387 93.025697 396.891356 101.372805 407.172513 101.372805L407.172513 101.372805 407.172513 101.372805zM246.674099 381.845685c0 10.276041 8.339946 18.61701 18.61701 18.61701l497.744321 1.517563c10.295484 0 18.622126-8.340969 18.622126-18.61701 0-10.277064-8.326643-18.622126-18.622126-18.622126l-497.744321-1.517563C255.014044 363.223558 246.674099 371.56862 246.674099 381.845685L246.674099 381.845685 246.674099 381.845685zM763.03543 542.794353l-497.744321-1.517563c-10.277064 0-18.61701 8.321526-18.61701 18.61701 0 10.3006 8.339946 18.622126 18.61701 18.622126l497.744321 1.517563c10.295484 0 18.622126-8.321526 18.622126-18.622126C781.657556 551.115879 773.330914 542.794353 763.03543 542.794353L763.03543 542.794353 763.03543 542.794353zM763.03543 719.526497l-497.744321-1.517563c-10.277064 0-18.61701 8.321526-18.61701 18.622126 0 10.295484 8.339946 18.61701 18.61701 18.61701l497.744321 1.517563c10.295484 0 18.622126-8.321526 18.622126-18.61701C781.657556 727.848023 773.330914 719.526497 763.03543 719.526497L763.03543 719.526497 763.03543 719.526497zM763.03543 719.526497" p-id="2859" fill="#bfbfbf" /></svg>
        <!-- 文件名 -->
        <p v-if="file.type=='other'&&file.url" class="fw-bold text-center">{{ file.name }}</p>
      </div>
    </div>
    <!-- 预览弹窗 -->
    <sp-drawer v-if="file.url" v-model="fullView">
      <img v-if="file.type=='img'&&file.url" class="img" :src="file.url">
      <iframe v-if="file.type=='pdf'&&file.url" scrolling="no" width="100%" height="700px" frameborder="0" :src="file.url" />
      <div v-if="file.type=='other'&&file.url" class="text-center">
        <p class="fw-bold mg-b-20">
          该文件暂不支持预览
        </p>
        <svg v-if="file.type=='other'&&file.url" t="1628148530356" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2858" width="200" height="200"><path d="M858.251002 65.538669 709.22692 65.538669l-0.204661 0.184195c-0.112564 0-0.204661-0.038886-0.312108-0.038886-13.967106 0-25.461905 10.3006-27.538193 23.667026l-0.248663 0.225127c-7.556093 33.045627-18.427698 76.41232-53.822836 76.41232l-246.183935-1.517563c-34.927487 0-45.37442-42.771129-53.413514-75.16491-1.36509-13.386892-12.069897-23.892153-25.568329-24.910343l-0.370437-0.375553L165.181063 64.020082c-20.552082 0-37.239136 16.666588-37.239136 37.239136l0 819.454394c0 20.571525 16.686031 37.238113 37.239136 37.238113l693.049472 1.517563c20.557198 0 37.239136-16.666588 37.239136-37.238113L895.469672 102.777805C895.490138 82.205257 878.788757 65.538669 858.251002 65.538669L858.251002 65.538669 858.251002 65.538669zM858.251002 922.232199l-693.069939-1.517563L165.181063 101.260242l126.998439 0c9.087982 36.459377 26.38288 100.44569 88.810698 100.44569l246.183935 1.517563c62.952774 0 80.69281-64.810075 88.940658-100.44569L858.230536 102.777805l0 819.454394L858.251002 922.232199 858.251002 922.232199 858.251002 922.232199zM407.172513 101.372805l209.110575 1.517563c10.295484 0 18.61701-8.346085 18.61701-18.622126 0-10.277064-8.321526-18.61701-18.61701-18.61701L407.172513 64.133669c-10.281157 0-18.622126 8.339946-18.622126 18.61701C388.550387 93.025697 396.891356 101.372805 407.172513 101.372805L407.172513 101.372805 407.172513 101.372805zM246.674099 381.845685c0 10.276041 8.339946 18.61701 18.61701 18.61701l497.744321 1.517563c10.295484 0 18.622126-8.340969 18.622126-18.61701 0-10.277064-8.326643-18.622126-18.622126-18.622126l-497.744321-1.517563C255.014044 363.223558 246.674099 371.56862 246.674099 381.845685L246.674099 381.845685 246.674099 381.845685zM763.03543 542.794353l-497.744321-1.517563c-10.277064 0-18.61701 8.321526-18.61701 18.61701 0 10.3006 8.339946 18.622126 18.61701 18.622126l497.744321 1.517563c10.295484 0 18.622126-8.321526 18.622126-18.622126C781.657556 551.115879 773.330914 542.794353 763.03543 542.794353L763.03543 542.794353 763.03543 542.794353zM763.03543 719.526497l-497.744321-1.517563c-10.277064 0-18.61701 8.321526-18.61701 18.622126 0 10.295484 8.339946 18.61701 18.61701 18.61701l497.744321 1.517563c10.295484 0 18.622126-8.321526 18.622126-18.61701C781.657556 727.848023 773.330914 719.526497 763.03543 719.526497L763.03543 719.526497 763.03543 719.526497zM763.03543 719.526497" p-id="2859" fill="#bfbfbf" /></svg>
      </div>
    </sp-drawer>
  </div>
</template>

<script type="text/ecmascript-6">
import { include } from '@/utils/check'
import spDrawer from '@/components/common/SpDrawer'
import { useFormItemProps } from '@/hooks/useForm'
import useModel from '@/hooks/useModel'
import { computed, ref, toRef } from '@vue/reactivity'
import { prop } from 'vue-class-component'
import { useSize } from '@/mixins/size'
import { checkFileUpdated, uploadFile } from '@/request/APIs/file'
import CryptoJS from 'crypto-js'
import { inject } from '@vue/runtime-core'
import SpLoading from '@/components/common/SpLoading/SpLoading'
export default {
  name: 'SpUpload',

  nameSpace: 'SpUpload',

  components: {
    SpLoading,
    spDrawer
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    file: {
      type: Object,
      default: () => {
        return {}
      }
    },

    width: { // 宽度
      type: Number,
      default: 222
    },

    height: { // 高度
      type: Number,
      default: 280
    },

    upTitle: {
      type: String,
      default: ''
    }
  },

  emits: ['delete'],

  setup (props, ctx) {
    // 显示预览
    const fullView = ref(false)
    // 放大预览
    const showFullView = () => {
      fullView.value = true
    }
    const { widthC, heightC } = useSize(toRef(props, 'width'), toRef(props, 'height'))
    const deleteFile = () => {
      ctx.emit('delete')
    }
    return {
      fullView,
      widthC,
      heightC,
      showFullView,
      deleteFile
    }
  }
}
</script>

<style scoped lang="less">
    .SpUpload{
        border:1px solid #c0ccda;
        border-radius: 5px;
        position: relative;
      &[class*=upload-failed]{
        border-color: red;
      }
        .main{
          text-align: center;
            overflow: hidden;
            .preview-iframe{
                overflow: hidden;
                pointer-events: none;
            }
        }
        .close-icon{
            background-color: #bfbfbf;
          text-align: center;
          line-height: 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
            border-radius: 10px;
            position: absolute;
            top:@gap/3*-1;
            right:@gap/3*-1;
            z-index: 99;
        }
        .mask{
            position: absolute;
            cursor: pointer;
            background-color: white;
            opacity: 0.01;
            z-index: 100;
            top: @gap;
        }
    }
    .img{
        object-fit: contain;
        width: 100%;
        //height:280px
    }
    .primary-icon{
        width: 155px;
        height: 53px;
        background: #F6F6F6;
        border: 1px solid #CDCDCD;
        border-radius: 5px;
    }
</style>
